module.exports = __webpack_public_path__ + "img/pko.32251017.png";